import React from 'react';
import styled from 'styled-components';
import { SkeletonLoader } from './BasicSkeletonShapes';

const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
`;

const Card = styled.div`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1c1c24' : '#ffffff')};
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-height: 480px;
`;

const ContentWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const TopContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BottomContent = styled.div`
  width: 100%;
  margin-top: auto;
`;

export const CardSkeleton = ({ isLoading = true }) => {
  return (
    <CardWrapper>
      <Card>
        <SkeletonLoader
          shape='circle'
          size='120px'
          isLoading={isLoading}
        />

        <ContentWrapper>
          <TopContent>
            <SkeletonLoader
              shape='line'
              height='22px'
              width='100%'
              isLoading={isLoading}
            />

            <SkeletonLoader
              shape='line'
              height='22px'
              width='100%'
              isLoading={isLoading}
            />
          </TopContent>

          <BottomContent>
            <SkeletonLoader
              shape='line'
              height='16px'
              width='100%'
              isLoading={isLoading}
            />
          </BottomContent>
        </ContentWrapper>
      </Card>
    </CardWrapper>
  );
};
